import campaignApiFactory from '../../modules/campaign/campaignApi';

/* Actions */
import {
  getCampaignsActionCreators,
  getSpecialCampaignsActionCreators,
  getNextCampaignsActionCreators,
  getCustomerSpecialCampaignsActionCreators,
} from '../actions/campaignActions';

/* Utils */
import {
  generateDefaultAsyncSaga,
  generateDefaultAsyncWatcher,
} from '../core/reduxUtils';

function campaignSagasFactory({storefrontApiClient}) {
  const campaignApi = campaignApiFactory(storefrontApiClient);

  const getCampaignSagas = generateDefaultAsyncSaga(
    campaignApi.getCampaigns,
    getCampaignsActionCreators,
    payload => [
      payload.params,
    ]
  );

  const getSpecialCampaignSagas = generateDefaultAsyncSaga(
    campaignApi.getSpecialCampaigns,
    getSpecialCampaignsActionCreators,
    payload => [
      payload.params,
    ]
  );

  const getCustomerSpecialCampaignSagas = generateDefaultAsyncSaga(
    campaignApi.getCustomerSpecialCampaigns,
    getCustomerSpecialCampaignsActionCreators,
    payload => [
      payload.params,
    ]
  );

  const getNextCampaignSagas = generateDefaultAsyncSaga(
    campaignApi.getCampaigns,
    getNextCampaignsActionCreators,
    payload => [
      payload.params,
    ]
  );

  const watchGetCampaigns = generateDefaultAsyncWatcher(
    'GET_CAMPAIGNS',
    getCampaignSagas
  );

  const watchGetSpecialCampaigns = generateDefaultAsyncWatcher(
    'GET_SPECIAL_CAMPAIGNS',
    getSpecialCampaignSagas
  );

  const watchGetCusomerSpecialCampaigns = generateDefaultAsyncWatcher(
    'GET_CUSTOMER_SPECIAL_CAMPAIGNS',
    getCustomerSpecialCampaignSagas
  );

  const watchGetNextCampaigns = generateDefaultAsyncWatcher(
    'GET_NEXT_CAMPAIGNS',
    getNextCampaignSagas
  );

  const campaignSagas = [
    watchGetCampaigns(),
    watchGetSpecialCampaigns(),
    watchGetCusomerSpecialCampaigns(),
    watchGetNextCampaigns(),
  ];

  return campaignSagas;
}

export default campaignSagasFactory;
